export default __webpack_public_path__ + "static/media/void.7a91e01b.svg";